export function buildKeyFromPattern(pattern, ctx = {}) {
    return pattern
        .replace(/\$\{platform\}/g, ctx.platform || "")
        .replace(/\$\{currency\}/g, ctx.currency || "")
        .replace(/\$\{providerCode\}/g, ctx.providerCode || ""); // nuevo
}

export function fieldNeedsCurrency(field) {
    return typeof field.pattern === "string" && field.pattern.includes("${currency}");
}

export function templateNeedsCurrency(template) {
    return (template.fields || []).some(fieldNeedsCurrency);
}

export const PROVIDER_TEMPLATES = {
    // First
    first: {
        filter: ["first"],
        fields: [
            { pattern: "first.url_backup_${platform}", label: "url_backup", placeholder: "" },
            { pattern: "first.url_${platform}", label: "url", placeholder: "" },
        ],
    },
    // PlatiPlus
    pps: {
        filter: ["PLATIPLUS"],
        fields: [
            { pattern: "PLATIPLUS_${platform}_${currency}", label: "valor", placeholder: "" },
        ],
    },
    // Ortiz Gaming
    otg: {
        filter: ["ortiz.gaming"],
        fields: [
            { pattern: "ortiz.gaming.cid_${platform}", label: "cid", placeholder: "" },
            { pattern: "ortiz.gaming.opid_${platform}", label: "opid", placeholder: "" },
        ],
    },
    // RedRake Gaming
    rrg: {
        filter: ["redrake"],
        fields: [
            { pattern: "redrake.operator_id_${platform}", label: "operator_id", placeholder: "" },
        ],
    },
    // 777 Gaming
    ngt: {
        filter: ["ngt7777"],
        fields: [
            { pattern: "ngt7777.url_${platform}", label: "url", placeholder: "" },
        ],
    },
    // DotWorkers
    dw: {
        filter: ["dotworkers"],
        fields: [
            { pattern: "dotworkers.secret_${platform}", label: "secret", placeholder: "" },
        ],
    },
    // Imperium
    adm: {
        filter: ["ADM"],
        fields: [
            { pattern: "ADM_${currency}_${platform}_HALL_ID", label: "hall_id", placeholder: "" },
            { pattern: "ADM_${platform}_URL", label: "url", placeholder: "" },
        ],
    },
    // Pascal Gaming
    psg: {
        filter: ["pascal"],
        fields: [
            { pattern: "pascal.partner_key.${platform}", label: "partner_key", placeholder: "" },
        ],
    },
    // Pragmatic
    pg: {
        filter: ["PRAGMATIC"],
        fields: [
            { pattern: "PRAGMATIC_${platform}_LAUNCH_URL", label: "launch_url", placeholder: "" },
            { pattern: "PRAGMATIC_${platform}_PROVIDERID", label: "providerid", placeholder: "" },
            { pattern: "PRAGMATIC_${platform}_SECRET_KEY", label: "secret_key", placeholder: "" },
            { pattern: "PRAGMATIC_${platform}_SECURE_LOGIN", label: "secure_login", placeholder: "" },
        ],
    },
    // BarbaraBang
    bbb: {
        filter: ["barbarabang"],
        fields: [
            { pattern: "barbarabang.accountid_${platform}", label: "accountid", placeholder: "" },
            { pattern: "barbarabang.accountname_${platform}", label: "accountname", placeholder: "" },
            { pattern: "barbarabang.secret_${platform}", label: "secret", placeholder: "" },
        ],
    },
    // GameArt
    gart: {
        filter: ["GAME_ART"],
        fields: [
            { pattern: "GAME_ART_USERNAME_${currency}_${platform}", label: "username", placeholder: "" },
            { pattern: "GAME_ART_PASSWORD_${currency}_${platform}", label: "password", placeholder: "" },
        ],
    },
    // AVIATRIX
    avt: {
        filter: ["aviatrix"],
        fields: [
            { pattern: "aviatrix.cid_${platform}", label: "cid", placeholder: "" },
        ],
    },
    // Eurasian
    eu: {
        filter: ["EURASIAN"],
        fields: [
            { pattern: "EURASIAN_REALM_${platform}_${currency}", label: "realm", placeholder: "" },
        ],
    },
    // NovusBet Casino
    nvbc: {
        filter: ["novuscasino"],
        fields: [
            { pattern: "novuscasino.access_key_${platform}", label: "access_key", placeholder: "" },
            { pattern: "novuscasino.private_key_${platform}", label: "private_key", placeholder: "" },
            { pattern: "novuscasino.public_key_${platform}", label: "public_key", placeholder: "" },
            { pattern: "novuscasino.site_id_${platform}", label: "site_id", placeholder: "" },
        ],
    },
    // Bets SW3
    betsw3: {
        filter: ["bsw3"],
        fields: [
            { pattern: "bsw3.currency.${currency}_${platform}", label: "currency", placeholder: "" },
            { pattern: "bsw3.maxBetNumber.${currency}_${platform}", label: "maxBetNumber", placeholder: "" },
            { pattern: "bsw3.maxQuote.${currency}_${platform}", label: "maxQuote", placeholder: "" },
            { pattern: "bsw3.maxValLive.${currency}_${platform}", label: "maxValLive", placeholder: "" },
            { pattern: "bsw3.maxValPrematch.${currency}_${platform}", label: "maxValPrematch", placeholder: "" },
            { pattern: "bsw3.maxWin.${currency}_${platform}", label: "maxWin", placeholder: "" },
            { pattern: "bsw3.minBetNumber.${currency}_${platform}", label: "minBetNumber", placeholder: "" },
            { pattern: "bsw3.minVal.${currency}_${platform}", label: "minVal", placeholder: "" },
            { pattern: "bsw3.${platform}.server_url", label: "server_url", placeholder: "" },
            { pattern: "bsw3.${platform}.sports_live_append", label: "sports_live_append", placeholder: "" },
            { pattern: "bsw3.${platform}.target", label: "target", placeholder: "" },
        ],
    },
    // One Touch
    ot: {
        filter: ["ONETOUCH"],
        fields: [
            { pattern: "ONETOUCH_SUB_PARTNER_${platform}", label: "sub_partner", placeholder: "" },
        ],
    },
    // Gamzix
    gzx: {
        filter: ["gamzix"],
        fields: [
            { pattern: "gamzix.url_${platform}", label: "url", placeholder: "" },
        ],
    },
    // Endorphina
    ed: {
        filter: ["ENDORPHINA"],
        fields: [
            { pattern: "ENDORPHINA_${platform}_NODE_ID", label: "node_id", placeholder: "" },
            { pattern: "ENDORPHINA_${platform}_SALT", label: "salt", placeholder: "" },
        ],
    },
    // Lucky Spin
    ls: {
        filter: ["LUCKYSPIN"],
        fields: [
            { pattern: "LUCKYSPIN_OPERATOR_${platform}", label: "operator", placeholder: "" },
            { pattern: "LUCKYSPIN_SECRET_KEY_${platform}", label: "secret_key", placeholder: "" },
        ],
    },
    // Tom Horn
    th: {
        filter: ["TOMHORN"],
        fields: [
            { pattern: "TOMHORN_PATNERID_${platform}", label: "patnerid", placeholder: "" },
            { pattern: "TOMHORN_SECRETKEY_${platform}", label: "secretkey", placeholder: "" },
        ],
    },
    // Urgent Games
    ug: {
        filter: ["URGENTGAMES"],
        fields: [
            { pattern: "URGENTGAMES_CASINO_ID_${platform}", label: "casino_id", placeholder: "" },
            { pattern: "URGENTGAMES_KEY_${platform}", label: "key", placeholder: "" },
            { pattern: "URGENTGAMES_TOKEN_${platform}", label: "token", placeholder: "" },
        ],
    },
    // Triple Cherry
    tc: {
        filter: ["CHERRY"],
        fields: [
            { pattern: "CHERRY_CASINO_${platform}", label: "platform", placeholder: "" },
        ],
    },
    // Kagaming
    kg: {
        filter: ["KAGAMING"],
        fields: [
            { pattern: "KAGAMING_LAUNCH_URL_${platform}", label: "launch_url", placeholder: "" },
            { pattern: "KAGAMING_PARTNER_NAME_${platform}", label: "partner_name", placeholder: "" },
            { pattern: "KAGAMING_ACCESS_KEY_${platform}", label: "access_key", placeholder: "" },
        ],
    },
    // Net Gaming
    ntg: {
        filter: ["netgaming"],
        fields: [
            { pattern: "netgaming.api_key_${platform}", label: "api_key", placeholder: "" },
        ],
    },
    // Iconic 21
    slbt: {
        filter: ["SL_BETER"],
        fields: [
            { pattern: "SL_BETER_BRAND_${platform}", label: "value", placeholder: "" },
        ],
    },
    // Golden Race
    gr: {
        filter: ["GR"],
        fields: [
            { pattern: "GR_${platform}_PRIVATE_KEY", label: "private_key", placeholder: "" },
            { pattern: "GR_${platform}_URL", label: "url", placeholder: "" },
        ],
    },
    // TvBet
    tv: {
        filter: ["TVBET"],
        fields: [
            { pattern: "TVBET_CLIENT_ID_${platform}", label: "client_id", placeholder: "" },
            { pattern: "TVBET_PRIVATE_KEY_${platform}", label: "private_key", placeholder: "" },
        ],
    },
    // Technical Wild Gaming
    twg: {
        filter: ["twg"],
        fields: [
            { pattern: "twg.apikey_${platform}", label: "apiKey", placeholder: "" },
            { pattern: "twg.operatorId_${platform}", label: "operatorId", placeholder: "" },
            { pattern: "twg.secretKey_${platform}", label: "secretKey", placeholder: "" },
            { pattern: "twg.siteId_${platform}", label: "siteId", placeholder: "" },
        ],
    },
    // Amigo Gaming
    agmg: {
        filter: ["amigogaming"],
        fields: [
            { pattern: "amigogaming.brand_${platform}", label: "brand", placeholder: "" },
            { pattern: "amigogaming.demo_${platform}", label: "demo", placeholder: "" },
            { pattern: "amigogaming.key_${platform}", label: "key", placeholder: "" },
            { pattern: "amigogaming.stylename_${platform}", label: "stylename", placeholder: "" },
        ],
    },
    // Casino Technology
    rgs: {
        filter: ["rgs"],
        fields: [
            { pattern: "rgs.key_${platform}", label: "key", placeholder: "" },
            { pattern: "rgs.psk_${platform}", label: "psk", placeholder: "" },
            { pattern: "rgs.web-launch_${platform}", label: "web-launch", placeholder: "" },
        ],
    },
    // DLV
    dlv: {
        filter: ["DLV"],
        fields: [
            { pattern: "DLV_API_AGG_${platform}", label: "api_agg", placeholder: "" },
        ],
    },
    // PopokGaming
    pkg: {
        filter: ["pokgaming"],
        fields: [
            { pattern: "pokgaming.partnerId_${platform}", label: "partnerId", placeholder: "" },
        ],
    },
    // Vibra Gaming
    vbrg: {
        filter: ["VIBRA_GAMING"],
        fields: [
            { pattern: "VIBRA_GAMING_SITE_ID_${platform}", label: "site_id", placeholder: "" },
        ],
    },
    // Mascot
    mc: {
        filter: ["MASCOT"],
        fields: [
            { pattern: "MASCOT_ID_${platform}", label: "id", placeholder: "" },
            { pattern: "MASCOT_LOGIN_${platform}", label: "login", placeholder: "" },
            { pattern: "MASCOT_PASSWORD_${platform}", label: "password", placeholder: "" },
            { pattern: "MASCOT_STRING_ID_${platform}", label: "string_id", placeholder: "" },
        ],
    },
    // RiseUP
    rup: {
        filter: ["riseup"],
        fields: [
            { pattern: "riseup.operatorId_${platform}", label: "operatorId", placeholder: "" },
            { pattern: "riseup.apiKey_${platform}", label: "apiKey", placeholder: "" },
        ],
    },
    // IGaming
    pgi: {
        filter: ["igaming"],
        fields: [
            { pattern: "igaming.api_key_${platform}", label: "api_key", placeholder: "" },
            { pattern: "igaming.token_igd_${platform}", label: "token_igd", placeholder: "" },
            { pattern: "igaming.url_${platform}", label: "url", placeholder: "" },
            { pattern: "igaming.brand_id_${platform}", label: "brand_id", placeholder: "" },
        ],
    },
    // Horses
    ho: {
        filter: ["HORSES"],
        fields: [
            { pattern: "HORSES_ID_GROUP_${platform}", label: "id_group", placeholder: "" },
        ],
    },
    // PatePlay
    ptp: {
        filter: ["ptp"],
        fields: [
            { pattern: "ptp.sitecode_${platform}", label: "sitecode", placeholder: "" },
        ],
    },
    // Anakatech
    ank: {
        filter: ["ank"],
        fields: [
            { pattern: "anakatech.brand_id_${platform}", label: "brand", placeholder: "" },
        ],
    },
    // Games Valley
    ifg: {
        filter: ["ifg"],
        fields: [
            { pattern: "games_valley.operator_id_${platform}", label: "operator_id", placeholder: "" },
            { pattern: "games_valley.api_key_${platform}", label: "api_key", placeholder: "" },
        ],
    },
    elxr: {
        filter: ["elxr"],
        fields: [
            { pattern: "elixir.secret_${platform}", label: "secret", placeholder: "" },
            { pattern: "elixir.token_${platform}", label: "token", placeholder: "" },
        ],
    },
    cmsw: {
        filter: ["cmsw"],
        fields: [
            { pattern: "cmsw.clientUsername_${platform}", label: "clientUsername", placeholder: "" },
            { pattern: "cmsw.clientPassword_${platform}", label: "clientPassword", placeholder: "" },
            { pattern: "cmsw.apiUrl_${platform}", label: "apiUrl", placeholder: "" },
            { pattern: "cmsw.publicKey_${platform}", label: "publicKey", placeholder: "" },
            { pattern: "cmsw.privateKey_${platform}", label: "privateKey", placeholder: "" },
            { pattern: "cmsw.clientKey_${platform}", label: "clientKey", placeholder: "" },
            { pattern: "cmsw.uiScriptUrl_${platform}", label: "uiScriptUrl", placeholder: "" },
        ],
    },
    besthorses: {
        filter: ["besthorses"],
        fields: [
            { pattern: "besthorse.apikey_${platform}", label: "apiKey", placeholder: "" },
            { pattern: "besthorse.url.national_${platform}", label: "national_url", placeholder: "" },
            { pattern: "besthorse.url.international_${platform}", label: "international_url", placeholder: "" },
        ],
    },
};


export const REVERSE_API_TEMPLATE = {
    fields: [
        { pattern: "${providerCode}_${platform}.auth", label: "auth", placeholder: "" },
        { pattern: "${providerCode}_${platform}.launch_url", label: "launch_url", placeholder: "" },
        { pattern: "${providerCode}_${platform}.private_key", label: "private_key", placeholder: "" },
        { pattern: "${providerCode}_${platform}.site_id", label: "site_id", placeholder: "" },
        { pattern: "${providerCode}_${platform}.send_player_info_on_launch", label: "send_player_info_on_launch", placeholder: "" },
    ],
};

export const GENERIC_TEMPLATE = {
    fields: [
        { pattern: "GENERIC_${platform}", label: "Clave genérica", placeholder: "Valor" },
    ],
};

// Agregar esto, el Set estático puede quedarse como fallback inicial vacío
export const REVERSE_API_REGEX = /^([a-z0-9]+)_([A-Z0-9]{2,6})\.(auth|launch_url|private_key|site_id)$/i;

export function isReverseApiKey(keyId) {
    return REVERSE_API_REGEX.test(String(keyId));
}

export function extractReverseApiProviderCode(keyId) {
    const m = REVERSE_API_REGEX.exec(String(keyId));
    return m ? m[1].toLowerCase() : null;
}

// Cambiar el Set a vacío, ya no necesita hardcodearse
export const REVERSE_API_PROVIDERS = new Set();

export function getProviderTemplate(providerCode) {
    if (!providerCode) return GENERIC_TEMPLATE;
    const key = String(providerCode).trim().toLowerCase();
    if (PROVIDER_TEMPLATES[key]) return PROVIDER_TEMPLATES[key];
    if (REVERSE_API_PROVIDERS.has(key)) return REVERSE_API_TEMPLATE;
    return GENERIC_TEMPLATE;
}
